<template>
    <div :class="['header', positionClass]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'CwHeader',
    props: {
        position: {
            type: String,
            default: '',
            validator: (value) => ['', 'fixed', 'sticky'].includes(value),
        },
    },
    computed: {
        positionClass() {
            return this.position ? `header-${this.position}` : '';
        },
    },
}
</script>
